import React, { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import { color, image } from "../../../resource";
import {
  Checkbox,
  Col,
  ConfigProvider,
  Divider,
  Form,
  Modal,
  Progress,
  Row,
  Table,
  Tag,
} from "antd";
import Input from "../../../components/Input/Input";
import {
  DeleteOutlined,
  InfoCircleFilled,
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import Select from "../../../components/Select/Select";
import Button from "../../../components/Button/Button";
import { numberFormatter } from "../../../utility/Formatter";
import { FlexCol } from "../../../components/Container/Container";
import { getShopGroup } from "../../../datasource/ShopGroupDatasoure";
import { getZones } from "../../../datasource/CustomerDatasource";
import { useEffectOnce } from "react-use";
import { checkAvailableShop, getFlashSaleShopById } from "../../../datasource/FlashSaleDatasource";
import dayjs from "dayjs";
import NewModalInfoCredit from "../../../components/Modal/NewModalInfoCredit";

export const FlashSaleStepThree: React.FC<{
  form: any;
  company: any;
}> = ({ form, company }) => {
  const _watchShops = Form.useWatch("shops", form);
  const [openModalShop, setOpenModalShop] = useState(false);
  const [modalDeleteShop, setModalDeleteShop] = useState(false);

  const [zoneList, setZoneList] = useState<any>([]);
  const [shopGroup, setShopGroup] = useState<any>({ count: 0, data: [] });
  const [sectionSearch, setSectionSearch] = useState<{
    searchZone: string | undefined;
    searchShopGroup: string | undefined;
    searchKeyWord: string | undefined;
  }>({
    searchZone: undefined,
    searchShopGroup: undefined,
    searchKeyWord: undefined,
  });
  const [infoCreditModal, setInfoCreditModal] = useState<{
    open: boolean;
    cusComId: any;
  }>({ open: false, cusComId: null });
  const watchSearchShop = Form.useWatch("searchShop", form);

  const fetchZone = async () => {
    const getZone = await getZones(company);
    setZoneList(getZone);
  };
  const fetchShopGroupList = async () => {
    await getShopGroup({
      company,
      take: 0,
      page: 0,
    }).then((res) => {
      setShopGroup({ count: res.responseData.count, data: res.responseData.data });
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchShopGroupList();
  });

  const fetchDataShop = async () => {
    await getFlashSaleShopById({
      flashSaleId: form.getFieldValue("flashSaleId"),
      page: 0,
      take: 0,
    }).then((data) => {
      const mapShop = data.data.map((shop: any) => ({ ...shop, isChecked: false }));
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        searchShop: mapShop,
        shops: mapShop,
      });
    });
  };

  useEffect(() => {
    form.getFieldValue("flashSaleId") && fetchDataShop();
  }, []);

  const onSearchShop = (keyWord?: string, zone?: string, shopGroup?: string) => {
    const shops = form.getFieldValue("shops");
    form.setFieldValue(
      "searchShop",
      shops.filter((shop: any) => {
        const matchZone = zone ? shop.zone === zone : true;
        const matchShopGroup = shopGroup ? shop.customerGroupName === shopGroup : true;
        const matchKeyWord = keyWord
          ? shop.customerName.includes(keyWord) || shop.customerNo.includes(keyWord)
          : true;
        return matchZone && matchShopGroup && matchKeyWord;
      }),
    );
  };

  const onDeleteShop = () => {
    const deleteShops = form.getFieldValue("shops").filter((shop: any) => shop.isChecked);
    const remainingShops = form
      .getFieldValue("shops")
      .filter(
        (shop: any) =>
          !deleteShops.some((s: any) => s.customerCompanyId === shop.customerCompanyId),
      );
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      shops: remainingShops,
      searchShop: remainingShops,
    });
  };

  const columes = [
    {
      title: (
        <Checkbox
          checked={
            watchSearchShop?.length > 0
              ? watchSearchShop?.every((shop: any) => {
                  return shop.isChecked;
                })
              : false
          }
          onChange={(e) => {
            const checked = e.target.checked;
            const mapShop = form.getFieldValue("shops");
            const mapSearchShop = form.getFieldValue("searchShop");

            const mapShopList = mapShop.map((shop: any) => {
              const map = mapSearchShop.find(
                (s: any) => s.customerCompanyId === shop.customerCompanyId,
              );
              return map ? { ...shop, isChecked: checked } : shop;
            });

            form.setFieldsValue({
              ...form.getFieldsValue(true),
              shops: mapShopList,
              searchShop: mapShopList,
            });
            onSearchShop(
              sectionSearch.searchKeyWord,
              sectionSearch.searchZone,
              sectionSearch.searchShopGroup,
            );
          }}
        />
      ),
      dataIndex: "isChecked",
      key: "isChecked",
      width: "3%",
      render: (value: any, record: any) => {
        return (
          <>
            <Checkbox
              checked={value}
              onChange={(e) => {
                const checked = e.target.checked;
                const mapShop = form.getFieldValue("shops");
                const mapSearchShop = form.getFieldValue("searchShop");
                const mapShopList = mapShop.map((shop: any) =>
                  shop.customerCompanyId === record.customerCompanyId
                    ? { ...shop, isChecked: checked }
                    : shop,
                );
                const mapSearchShopList = mapSearchShop.map((shop: any) =>
                  shop.customerCompanyId === record.customerCompanyId
                    ? { ...shop, isChecked: checked }
                    : shop,
                );
                form.setFieldsValue({
                  ...form.getFieldsValue(true),
                  shops: mapShopList,
                  searchShop: mapSearchShopList,
                });
                onSearchShop(
                  sectionSearch.searchKeyWord,
                  sectionSearch.searchZone,
                  sectionSearch.searchShopGroup,
                );
              }}
            />
          </>
        );
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3'>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ประเภทชำระเงิน",
      dataIndex: "termPayment",
      key: "termPayment",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value === "COD" ? "เงินสด" : "เครดิต"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "วงเงินคงเหลือ (฿)",
      dataIndex: "termPayment",
      key: "termPayment",
      width: "15%",
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {row.termPayment !== "COD" ? (
              <>
                <Progress
                  strokeColor={color.primary}
                  percent={row.percentCreditBalance}
                  showInfo={false}
                />
                <Row justify='space-between'>
                  <Col>
                    <Text color={row.creditAvailable < 0 ? "error" : "BK"} fontWeight={600}>
                      {numberFormatter(row.creditAvailable, 2)}
                    </Text>{" "}
                    <Text level={6} color={row.creditAvailable < 0 ? "error" : "Text3"}>
                      ({numberFormatter(row.percentCreditBalance, 2)}%)
                    </Text>
                    <br />
                  </Col>
                  <Col>
                    <Text>/{numberFormatter(row.creditLimit, 2)}</Text>
                    <InfoCircleFilled
                      style={{ marginLeft: 4, cursor: "pointer" }}
                      onClick={() => {
                        setInfoCreditModal({ open: true, cusComId: row.customerCompanyId });
                      }}
                    />
                  </Col>
                </Row>
                {row.creditAvailable < 0 && (
                  <Tag
                    color={row.creditAvailable < 0 ? "error" : "primary"}
                    style={{ border: "none" }}
                  >
                    <Text level={6} color='error' fontWeight={600}>
                      วงเงินเกิน
                    </Text>
                  </Tag>
                )}
              </>
            ) : (
              <Text>-</Text>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Form form={form} layout='vertical'>
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            ร้านค้าที่เข้าร่วม <b style={{ color: color.error }}>*</b>
          </span>
        </div>
        <Row justify={"space-between"} gutter={8}>
          {form.getFieldValue("shops")?.length > 0 ? (
            <>
              <Col span={8}>
                <Input
                  value={sectionSearch.searchKeyWord}
                  placeholder='ค้นหาชื่อร้านค้า'
                  suffix={<SearchOutlined />}
                  allowClear
                  onPressEnter={(e: any) =>
                    onSearchShop(
                      e.target.value,
                      sectionSearch.searchZone,
                      sectionSearch.searchShopGroup,
                    )
                  }
                  onChange={(e) => {
                    if (!e.target.value) {
                      form.setFieldValue("searchShop", form.getFieldValue("shops"));
                    }
                    setSectionSearch({
                      searchZone: sectionSearch.searchZone,
                      searchShopGroup: sectionSearch.searchShopGroup,
                      searchKeyWord: e.target.value,
                    });
                  }}
                />
              </Col>
              <Col span={3}>
                <Select
                  value={sectionSearch.searchZone}
                  data={
                    zoneList?.map((zone) => ({
                      label: zone.zoneName,
                      value: zone.zoneName,
                      key: zone.zoneName,
                    })) || []
                  }
                  placeholder='เลือกเขต'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSectionSearch({
                      searchZone: e,
                      searchShopGroup: sectionSearch.searchShopGroup,
                      searchKeyWord: sectionSearch.searchKeyWord,
                    });
                    onSearchShop(sectionSearch.searchKeyWord, e, sectionSearch.searchShopGroup);
                  }}
                />
              </Col>
              <Col span={4}>
                <Select
                  value={sectionSearch.searchShopGroup}
                  data={
                    shopGroup?.data?.map((group) => ({
                      label: group.customerGroupName,
                      value: group.customerGroupName,
                      key: group.customerGroupId,
                    })) || []
                  }
                  placeholder='กลุ่มร้านค้า'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSectionSearch({
                      searchZone: sectionSearch.searchZone,
                      searchShopGroup: e,
                      searchKeyWord: sectionSearch.searchKeyWord,
                    });
                    onSearchShop(sectionSearch.searchKeyWord, sectionSearch.searchZone, e);
                  }}
                />
              </Col>
              <Col span={3}>
                <Button
                  typeButton='primary-light'
                  title='ล้างการค้นหา'
                  onClick={() => {
                    setSectionSearch({
                      searchZone: undefined,
                      searchShopGroup: undefined,
                      searchKeyWord: undefined,
                    });
                    form.setFieldValue("searchShop", form.getFieldValue("shops"));
                  }}
                />
              </Col>
              <Col span={2} />
              <Col style={{ paddingTop: "10px" }}>
                {form?.getFieldValue("shops")?.some((shop: any) => shop.isChecked) && (
                  <DeleteOutlined
                    onClick={() => setModalDeleteShop(true)}
                    style={{ fontSize: "20px", color: color.error, cursor: "pointer" }}
                  />
                )}
                {modalDeleteShop && (
                  <Modal
                    open={modalDeleteShop}
                    centered
                    closable={true}
                    maskClosable={false}
                    okText='บันทึก'
                    cancelText='ยกเลิก'
                    title={
                      <Text fontWeight={600} level={2}>
                        ลบร้านค้าที่เลือก{" "}
                        {form.getFieldValue("shops").filter((shop: any) => shop.isChecked)?.length}{" "}
                        ร้าน
                      </Text>
                    }
                    okButtonProps={{
                      style: { backgroundColor: color.error, borderColor: color.error },
                    }}
                    cancelButtonProps={{
                      style: { borderColor: color.error, color: color.error },
                    }}
                    width={500}
                    onOk={() => {
                      onDeleteShop();
                      setModalDeleteShop(false);
                    }}
                    onCancel={() => setModalDeleteShop(false)}
                  >
                    <Text color='Text3'>โปรดยืนยันการลบร้านค้า</Text>
                    <Divider size='small' />
                  </Modal>
                )}
              </Col>
            </>
          ) : (
            <Col span={21} />
          )}
          <Col span={3}>
            <Button
              typeButton='primary'
              title='+ เพิ่มร้านค้า'
              onClick={() => setOpenModalShop(true)}
            />
          </Col>
        </Row>
        {form?.getFieldValue("shops")?.length > 0 && (
          <>
            <br />
            <Row justify={"end"} gutter={8}>
              <Col>
                <Text color='Text3'>
                  จำนวนที่เลือก {form.getFieldValue("searchShop")?.length || 0} ร้าน
                </Text>
              </Col>
            </Row>
          </>
        )}
        <br />
        <Form.Item name='searchShop' noStyle>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  headerColor: "#FFFFFF",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  //rowHoverBg: "none",
                },
              },
            }}
          >
            <Table
              // loading={loading}
              columns={columes}
              dataSource={form.getFieldValue("searchShop") || []}
              //rowKey='customerCompanyId'
              tableLayout='fixed'
              scroll={{
                x: form.getFieldValue("coId") ? 1500 : undefined,
                y: 520,
              }}
              pagination={false}
            />
          </ConfigProvider>
        </Form.Item>
      </Form>
      {openModalShop && (
        <ModalShopFlashSale
          open={openModalShop}
          onClose={() => setOpenModalShop(false)}
          form={form}
          company={company}
          onSubmit={(shops) => {
            const mapShops = shops.map((shop) => ({ ...shop, isChecked: false }));
            form.setFieldsValue({
              ...form.getFieldsValue(true),
              searchShop: [...form.getFieldValue("searchShop"), ...mapShops],
              shops: [...form.getFieldValue("shops"), ...mapShops],
            });
            onSearchShop(
              sectionSearch.searchKeyWord,
              sectionSearch.searchZone,
              sectionSearch.searchShopGroup,
            );
            setOpenModalShop(false);
          }}
        />
      )}
      {infoCreditModal.open && (
        <NewModalInfoCredit
          open={infoCreditModal.open}
          onClose={() => setInfoCreditModal({ open: false, cusComId: null })}
          cusComId={infoCreditModal.cusComId}
        />
      )}
    </>
  );
};

const ModalShopFlashSale: React.FC<{
  open: boolean;
  onClose: () => void;
  form: any;
  company: any;
  onSubmit?: any;
}> = ({ open, onClose, form, company, onSubmit }) => {
  const [zoneList, setZoneList] = useState<any[]>([]);
  const [storeList, setStoreList] = useState<any[]>([]);

  const [sectionLeft, setSectionLeft] = useState<{
    searchZone: string | undefined;
    searchShopGroup: string | undefined;
    searchKeyWord: string | undefined;
  }>({
    searchZone: undefined,
    searchShopGroup: undefined,
    searchKeyWord: undefined,
  });

  const [sectionRight, setSectionRight] = useState<{
    searchZone: string | undefined;
    searchShopGroup: string | undefined;
    searchKeyWord: string | undefined;
  }>({
    searchZone: undefined,
    searchShopGroup: undefined,
    searchKeyWord: undefined,
  });

  const [shopGroup, setShopGroup] = useState<{ count: number; data: any[] }>({
    count: 0,
    data: [],
  });

  const fetchZone = async () => {
    const getZone = await getZones(company);
    setZoneList(getZone);
  };
  const fetchShopGroupList = async () => {
    await getShopGroup({
      company,
      take: 0,
      page: 0,
    }).then((res) => {
      setShopGroup({ count: res.responseData.count, data: res.responseData.data });
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchShopGroupList();
  });

  const fetchStoreList = async () => {
    const getStoreList = await checkAvailableShop({
      company,
      startDate: dayjs(form.getFieldValue("mainStartDate")).toISOString(),
      endDate: dayjs(form.getFieldValue("mainEndDate")).toISOString(),
      flashSaleId: form.getFieldValue("flashSaleId"),
    });
    let availableStoreList = getStoreList
      .filter((store: any) => !store.isDuplicate)
      .map((s: any) => ({ ...s, isChecked: false }));

    const selectedShop = form.getFieldValue("shops") || [];
    if (selectedShop.length > 0) {
      availableStoreList = availableStoreList.filter(
        (store: any) =>
          !selectedShop.some(
            (shop: any) => `${shop.customerCompanyId}` === `${store.customerCompanyId}`,
          ),
      );
    }
    setStoreList(availableStoreList);
  };

  useEffect(() => {
    fetchStoreList();
  }, []);

  return (
    <Modal
      maskClosable={false}
      open={open}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      title={
        <Row gutter={8}>
          <Col>
            <Text level={4} fontWeight={600}>
              เพิ่มร้านค้า
            </Text>
          </Col>
          <Col style={{ paddingTop: "2px" }}>
            <Text level={5} fontWeight={600} color='Text3'>
              ร้านค้าที่สามารถเข้าร่วม Flash Sale ได้เท่านั้น
            </Text>
          </Col>
        </Row>
      }
    >
      <Row gutter={24} justify={"space-between"}>
        <ShopSelectedSection
          checked={false}
          stateSearch={sectionLeft}
          setStateSearch={setSectionLeft}
          storeList={storeList}
          setStoreList={setStoreList}
          zoneList={zoneList}
          shopGroup={shopGroup}
        />
        <Col span={1}>
          <SwapOutlined style={{ fontSize: "20px", marginTop: "150px", color: "#6B7995" }} />
        </Col>
        <ShopSelectedSection
          checked={true}
          stateSearch={sectionRight}
          setStateSearch={setSectionRight}
          storeList={storeList}
          setStoreList={setStoreList}
          zoneList={zoneList}
          shopGroup={shopGroup}
        />
      </Row>
      <Divider size='small' />
      <Row justify={"end"} gutter={12}>
        <Col span={3}>
          <Button
            type='primary'
            title='บันทึก'
            onClick={() =>
              onSubmit(storeList.length > 0 ? storeList.filter((shop) => shop.isChecked) : [])
            }
          />
        </Col>
      </Row>
    </Modal>
  );
};

const ShopSelectedSection = ({
  checked,
  stateSearch,
  setStateSearch,
  storeList,
  setStoreList,
  zoneList,
  shopGroup,
}: any) => {
  const handleSearchShop = (zone?: string, group?: string, keyword?: string, checked?: boolean) => {
    const search = (keyword || "").trim().toLowerCase();
    const filtered = storeList.filter((store: any) => {
      const matchChecked = store.isChecked === checked;
      const matchZone = zone ? store.zone === zone : true;
      const matchGroup = group ? store.customerGroupName === group : true;
      const matchKeyword = search
        ? String(store.customerName || "")
            .toLowerCase()
            .includes(search) ||
          String(store.customerNo || "")
            .toLowerCase()
            .includes(search)
        : true;
      return matchChecked && matchZone && matchGroup && matchKeyword;
    });
    return filtered;
  };
  const filteredShopList = handleSearchShop(
    stateSearch.searchZone,
    stateSearch.searchShopGroup,
    stateSearch.searchKeyWord,
    checked,
  );
  const handleSelectAll = () => {
    const updatedList = storeList.map((shop) => {
      const match = filteredShopList.find((s) => s.customerCompanyId === shop.customerCompanyId);
      if (match) {
        return { ...shop, isChecked: !checked };
      }
      return shop;
    });
    setStoreList(updatedList);
  };
  const handleSelectOne = (cusComId: number) => {
    const updatedList = storeList.map((shop) => {
      if (shop.customerCompanyId === cusComId) {
        return { ...shop, isChecked: !shop.isChecked };
      }
      return shop;
    });
    setStoreList(updatedList);
  };

  return (
    <Col span={11} style={{ borderColor: color.Grey, paddingLeft: "0px", paddingRight: "0px" }}>
      <div
        style={{
          padding: "10px",
          background: "#1B4586",
          borderRadius: "5px",
          marginBottom: "8px",
        }}
      >
        <Row>
          <Col>
            <Text style={{ color: "white", fontSize: "15px" }} fontWeight={600}>
              {checked ? "ร้านค้าที่เลือก" : "เลือกร้านค้า"}
            </Text>
          </Col>
        </Row>
        <Divider style={{ backgroundColor: "white", margin: "10px 0" }} />
        <Row gutter={8}>
          <Col span={8}>
            <Text style={{ color: "white" }}>ค้นหารายเขต</Text>
            <Select
              style={{ width: "100%" }}
              data={zoneList.map((z) => ({ label: z.zoneName, key: z.zoneName }))}
              onChange={(value) => {
                setStateSearch({ ...stateSearch, searchZone: value });
              }}
              allowClear
              value={stateSearch.searchZone}
            />
          </Col>
          <Col span={8}>
            <Text style={{ color: "white" }}>ค้นหากลุ่มลูกค้า</Text>
            <Select
              style={{ width: "100%" }}
              data={shopGroup.data.map((z) => ({
                label: z.customerGroupName,
                key: z.customerGroupName,
              }))}
              onChange={(e) => {
                setStateSearch({ ...stateSearch, searchShopGroup: e });
                handleSearchShop(stateSearch.searchZone, e, stateSearch.searchKeyWord);
              }}
              allowClear
              value={stateSearch.searchShopGroup}
            />
          </Col>
          <Col span={8}>
            <Text style={{ color: "white" }}>ค้นหาร้านค้า</Text>
            <Input
              suffix={<SearchOutlined style={{ color: color.Grey }} />}
              placeholder='ระบุชื่อหรือรหัสร้านค้า'
              allowClear
              value={stateSearch.searchKeyWord}
              onChange={(e) => {
                setStateSearch({
                  ...stateSearch,
                  searchKeyWord: e.target.value,
                });
              }}
              onPressEnter={(e: any) => {
                setStateSearch({
                  ...stateSearch,
                  searchKeyWord: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
      </div>
      <Row
        style={{
          padding: "8px",
          background: "#6B7995",
          borderRadius: "4px",
        }}
      >
        <Col span={18} style={{ color: "white" }}>
          {filteredShopList.filter((s) => s.isChecked === checked).length} ร้าน
        </Col>
        {filteredShopList.some((x) => x.isChecked === checked) && (
          <Col
            span={6}
            style={{
              color: "white",
              cursor: "pointer",
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => {
              handleSelectAll();
            }}
          >
            {!checked ? (
              <>
                <PlusCircleOutlined />
                &nbsp;เลือกทั้งหมด
              </>
            ) : (
              <>
                <MinusCircleOutlined />
                &nbsp;ลบทั้งหมด
              </>
            )}
          </Col>
        )}
      </Row>
      {filteredShopList.length !== 0 ? (
        <Col
          style={{
            overflow: "scroll",
            minHeight: "300px",
            maxHeight: "300px",
            border: "solid",
            borderColor: "#F3F6F9",
            borderRadius: "4px",
          }}
        >
          {filteredShopList?.map((shop) => (
            <Row
              key={shop.customerCompanyId}
              justify={"space-between"}
              style={{ alignItems: "center" }}
            >
              <FlexCol style={{ padding: "4px 8px" }}>
                <Text level={5}>{shop.customerName}</Text>
                <Text level={6} color='Text3'>
                  {shop.customerNo} • {shop.zone}{" "}
                  {shop.customerGroupName ? `• ${shop.customerGroupName}` : null}
                </Text>
              </FlexCol>
              <FlexCol style={{ padding: "4px 18px" }}>
                {!checked ? (
                  <PlusCircleOutlined
                    style={{
                      fontSize: "20px",
                      color: color.primary,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleSelectOne(shop.customerCompanyId);
                    }}
                  />
                ) : (
                  <MinusCircleOutlined
                    style={{
                      fontSize: "20px",
                      color: color.error,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleSelectOne(shop.customerCompanyId);
                    }}
                  />
                )}
              </FlexCol>
            </Row>
          ))}
        </Col>
      ) : (
        <Row
          style={{
            overflow: "scroll",
            minHeight: "300px",
            border: "solid",
            borderColor: "#F3F6F9",
            borderRadius: "4px",
            padding: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={image.empty_shop}
            style={{
              width: 48,
              height: 48,
            }}
          />
          <br />
          <Text level={6} align={"center"} style={{ color: "#BABCBE" }}>
            ไม่มีร้านค้า
          </Text>
        </Row>
      )}
    </Col>
  );
};
